import React, { useEffect, useState } from "react";
import axios from "axios";
import QRCode from "qrcode.react";
import { Link, useLocation } from "react-router-dom";

const AuthenticatorEnrollmentPage = () => {
  const location = useLocation();
  const token = new URLSearchParams(location.search).get("token") || "";
  const [enrollment, setEnrollment] = useState(null);
  const [code, setCode] = useState("");
  const [message, setMessage] = useState("");
  const [complete, setComplete] = useState(false);

  useEffect(() => {
    if (!token) {
      setMessage("Enrollment link is invalid.");
      return;
    }
    axios
      .post("coinSeller/enrollment/start", { token })
      .then((res) => {
        if (res.data.status) setEnrollment(res.data);
        else setMessage(res.data.message);
      })
      .catch((error) =>
        setMessage(error.response?.data?.message || "Enrollment link is invalid or expired."),
      );
  }, [token]);

  const confirmEnrollment = (event) => {
    event.preventDefault();
    if (!/^\d{6}$/.test(code)) {
      setMessage("Enter the current 6-digit code from your authenticator app.");
      return;
    }
    axios
      .post("coinSeller/enrollment/confirm", { token, code })
      .then((res) => {
        setMessage(res.data.message);
        if (res.data.status) {
          setComplete(true);
          setEnrollment(null);
        }
      })
      .catch((error) =>
        setMessage(error.response?.data?.message || "Unable to complete enrollment."),
      );
  };

  return (
    <div className="login-page back__style">
      <div className="container">
        <div className="row justify-content-md-center">
          <div className="col-md-12 col-lg-5">
            <div className="card login-box-container">
              <div className="card-body text-center">
                <div className="authent-logo mb-4">
                  <span className="text-danger h2">Set up Google Authenticator</span>
                </div>
                {enrollment && (
                  <>
                    <p>Scan this QR code in Google Authenticator for {enrollment.email}.</p>
                    <div className="my-4">
                      <QRCode
                        value={enrollment.otpAuthUri}
                        size={240}
                        level="M"
                        includeMargin
                      />
                    </div>
                    <p>The QR code is available only while this one-time link remains valid.</p>
                    <details className="text-left mb-4">
                      <summary>Can't scan? Enter a setup key manually</summary>
                      <div className="mt-3">
                        <p className="mb-1"><strong>Account:</strong> {enrollment.email}</p>
                        <p className="mb-1"><strong>Type:</strong> Time based</p>
                        <p className="mb-1"><strong>Setup key:</strong></p>
                        <code style={{ wordBreak: "break-all", userSelect: "all" }}>
                          {enrollment.manualEntryKey}
                        </code>
                      </div>
                    </details>
                    <form onSubmit={confirmEnrollment}>
                      <input
                        className="form-control text-center mb-3"
                        type="text"
                        inputMode="numeric"
                        maxLength="6"
                        placeholder="Current 6-digit code"
                        value={code}
                        onChange={(event) =>
                          setCode(event.target.value.replace(/\D/g, "").slice(0, 6))
                        }
                      />
                      <button type="submit" className="btn btn-danger w-100">
                        Confirm authenticator
                      </button>
                    </form>
                  </>
                )}
                {message && <p className={complete ? "text-success" : "text-danger"}>{message}</p>}
                {complete && <Link to="/login">Continue to sign in</Link>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthenticatorEnrollmentPage;
